import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const logoBase64 = null;

const styles = StyleSheet.create({
  page: {
    fontFamily: "Helvetica",
    paddingTop: 95,
    paddingBottom: 60,
    paddingHorizontal: 40,
    fontSize: 11,
    lineHeight: 1.5,
    backgroundColor: "#FFFFFF",
  },

  // HEADER
  header: {
    position: "absolute",
    top: 20,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#D9D9D9",
    paddingBottom: 10,
  },

  logo: {
    width: 45,
    height: 45,
  },

  titleContainer: {
    flex: 1,
    marginHorizontal: 15,
  },

  title: {
    fontSize: 18,
    fontFamily: "Helvetica-Bold",
    textAlign: "center",
  },

  reportInfo: {
    width: 180,
  },

  reportInfoText: {
    fontSize: 8,
    marginBottom: 3,
    textAlign: "right",
  },

  // FOOTER
  footer: {
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40,
    borderTopWidth: 1,
    borderTopColor: "#D9D9D9",
    paddingTop: 5,
    textAlign: "center",
    fontSize: 9,
    color: "#666",
  },

  // SECTION QUESTION
  questionBlock: {
    marginBottom: 15,
    borderWidth: 1,
    borderColor: "#E5E5E5",
    borderRadius: 4,
    padding: 10,
  },

  questionTitle: {
    fontSize: 13,
    fontFamily: "Helvetica-Bold",
    marginBottom: 8,
  },

  answerContainer: {
    marginBottom: 8,
  },

  answerText: {
    fontSize: 11,
    textAlign: "justify",
    lineHeight: 1.5,
  },

  // SOUS QUESTION
  childContainer: {
    marginTop: 10,
    marginLeft: 12,
    paddingLeft: 10,
    borderLeftWidth: 2,
    borderLeftColor: "#BDBDBD",
  },

  childTitle: {
    fontSize: 12,
    fontFamily: "Helvetica-Bold",
    marginBottom: 5,
  },

  noAnswer: {
    fontSize: 10,
    color: "#888",
    fontStyle: "italic",
  },
});

const renderComment = (comment) => {
  if (!comment || !comment.trim()) return null;

  return (
    <View style={styles.answerContainer}>
      <Text style={styles.answerText}>
        {String(comment).replace(/\r\n/g, "\n")}
      </Text>
    </View>
  );
};

const MyDocument = ({ report, userLang }) => {
  const formattedDate = report?.dateComplete
    ? new Date(report.dateComplete).toLocaleString()
    : "";

  const questions = Array.isArray(report?.listeQuestions)
    ? report.listeQuestions
    : [];

  const responses = Array.isArray(report?.listeReponses)
    ? report.listeReponses
    : [];

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap>
        {/* HEADER */}
        <View style={styles.header} fixed>
          {logoBase64 ? (
            <Image src={logoBase64} style={styles.logo} />
          ) : (
            <View style={{ width: 45 }} />
          )}

          <View style={styles.titleContainer}>
            <Text style={styles.title}>
              {userLang === "EN"
                ? report?.titleRepportEn || ""
                : report?.titleRepportFr || ""}
            </Text>
          </View>

          <View style={styles.reportInfo}>
            <Text style={styles.reportInfoText}>Date: {formattedDate}</Text>

            <Text style={styles.reportInfoText}>
              Restaurant: {report?.nomEmplacement || ""}
            </Text>

            <Text style={styles.reportInfoText}>
              Author: {report?.username || ""}
            </Text>
          </View>
        </View>

        {/* QUESTIONS */}
        {questions.map((q, index) => {
          const questionResponses = responses.filter(
            (rep) => rep?.idQuestion === q?.id,
          );

          return (
            <View key={`question-${q.id}`} style={styles.questionBlock}>
              <Text style={styles.questionTitle}>
                {index + 1}.{" "}
                {userLang === "EN" ? q?.textEn || "" : q?.textFr || ""}
              </Text>
              {questionResponses.length > 0 ? (
                questionResponses.map((rep) => (
                  <View key={`response-${rep.id}`}>
                    {renderComment(rep?.commentaire)}
                  </View>
                ))
              ) : (
                <Text style={styles.noAnswer}>
                  {userLang === "EN" ? "No response" : "Aucune réponse"}
                </Text>
              )}

              {/* SOUS-QUESTIONS */}
              {Array.isArray(q?.childQuestions) &&
                q.childQuestions.map((child) => {
                  const childResponses = responses.filter(
                    (rep) => rep?.idQuestion === child?.id,
                  );

                  return (
                    <View
                      key={`child-${child.id}`}
                      style={styles.childContainer}
                    >
                      <Text style={styles.childTitle}>
                        {userLang === "EN"
                          ? child?.textEn || ""
                          : child?.textFr || ""}
                      </Text>

                      {childResponses.length > 0 ? (
                        childResponses.map((rep) => (
                          <View key={`child-response-${rep.id}`}>
                            {renderComment(rep?.commentaire)}
                          </View>
                        ))
                      ) : (
                        <Text style={styles.noAnswer}>
                          {userLang === "EN" ? "No response" : "Aucune réponse"}
                        </Text>
                      )}
                    </View>
                  );
                })}
            </View>
          );
        })}

        {/* FOOTER */}
        <Text
          style={styles.footer}
          fixed
          render={({ pageNumber, totalPages }) =>
            `${userLang === "EN" ? "Page" : "Page"} ${pageNumber} / ${totalPages}`
          }
        />
      </Page>
    </Document>
  );
};
export default MyDocument;
